import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { Alerts } from './alerts';
import { ALERTS } from './mock-alerts';

@Injectable()
export class AlertsService
{
    criticalAlertSent = new Subject<string>();
    criticalAlertCleared = new Subject();

    constructor() { }

    getAlerts(): Observable<Alerts[]>
    {
        return of(ALERTS);
    }

    sendCriticalAlert(message: string)
    {
        this.criticalAlertSent.next(message);
    }

    clearCriticalAlert()
    {
        this.criticalAlertCleared.next();
    }

}
